export default {
  // labels
  'label.register_title1': 'Qeydiyyatdan keç',
  'label.register_title2': 'Ödəniş və köçürmələri həyata keçir',
  'label.register_title3': 'Seçilmişləri tənzimlə',
  'label.register_description1': 'Sadəcə nömrə ilə qeydiyyatdan keç və komissiyasız ödənişlər et.',
  'label.register_description2': '17 kateqoriyada 1000+ xidmət üzrə komissiyasız ödənişlər, eyni zamanda, nömrə və kart ilə köçürmələrdən faydalan.',
  'label.register_description3': 'Seçilmiş əməliyyatları artır, ödəniş və köçürmələri daha tez həyata keçir.',
  'label.auth.least_symbol': 'Ən azı 8 simvol',
  'label.auth.most_symbol': 'Ən çox 30 simvol',
  'label.auth.min_max_symbols': 'Minimum 8, maksimum 30 simvol',
  'label.auth.uppercase': 'Minimum 1 böyük hərf',
  'label.auth.lowercase': 'Kiçik hərflər',
  'label.auth.number': 'Minumum 1 rəqəm',
  'label.auth.character': '1 xüsusi simvol: (@=$%)(#^&)]]',
  'label.register_error.whitespace': 'Boşluq buraxma',
  'label.register_error.match': 'Şifrə uyğun deyil',
  'label.login_title': 'Sürətli, Etibarlı və  {easy}',
  'label.login_title.emanat': 'Tez, Etibarlı və  {easy}',
  'label.cobrand.alert': 'MPAY kart sifarişinin tamamlanması üçün {sima} SİMA ilə kimliyini təsdiqləməlisən.',
  'label.login_description': 'Daxil ola və ya qeydiyyatdan keçərək minlərlə xidmət üzrə ödəniş və köçürmələri bir neçə saniyə ərzində həyata keçirə bilərsən.',
  'label.login_description_new': ' Minlərlə xidmətə ödəniş və köçürmələri bir toxunuşla, anında və etibarlı şəkildə həyata keçir.',
  'label.phone_number': 'Telefon nömrəsi',
  'label.password': 'Şifrə',
  'label.old_password': 'Köhnə şifrə',
  'label.new_password': 'Yeni şifrə',
  'label.confirm_password': 'Yeni şifrənin təkrarı',
  'label.remember': 'Yadda saxla',
  'label.dashboard': 'Alətlər paneli',
  'label.favorites.added': 'Seçilmişlərə əlavə olundu',
  'label.favorites.added.desc': 'Ödəniş uğurla seçilmişlərə əlavə olundu. Sag paneldən ümumi seçilmişlərə baxa bilərsiniz.',
  'label.favorites': 'Seçilmişlər',
  'label.favorites.search': 'Seçilmişlərdə axtar',
  'label.favorites.card': 'Sən seçilmişlərdəsən!',
  'label.autoPayment.card': 'Avtomatik ödənişlərdəsən!',
  'label.favorites.description': 'Seçilmiş əməliyyatları artıraraq ödəniş və köçürmələrini daha tez həyata keçir.',
  'label.autoPayment.description': 'Avtomatik ödənişləri artıraraq ödənişlərinizi gecikmədən avtomatik həyata keçirə bilərsiniz.',
  'label.favorites.not_found.title': 'Heç bir seçilmiş tapılmadı.',
  'label.favorites.not_found.description': 'Seçilmiş əməliyyatları artıraraq ödəniş və köçürmələrini daha tez həyata keçirə bilərsən.',
  'label.favorites.delete.description': 'Seçilmişi sildikdə ona bağlı olan avto-ödənişlər də silinmiş olacaq.',
  'label.automobiles.delete.description': '{automobile} nömrəli avtomobil silinəcək',

  'label.switch.heading': 'Hesabına giriş edildi',
  'label.switch.description': 'Əgər sən deyilsənsə, təhlükəsizlik üçün aşağıdakılardan birini seçə bilərsən.',
  'label.payment_info': 'Ödəniş məlumatları',

  'label.autopayment': 'Avtomatik ödənişlər',
  'label.autopayment.new': 'Yeni',
  'label.autopayment.empty': 'Heç bir avtomatik ödəniş tapılmadı.',
  'label.autopayment.search.empty': 'Axtarışa uyğun avtomatik ödəniş tapılmadı..',
  'label.autopayment.create': 'Avtomatik ödəniş yarat',
  'label.autopayment.choose.favorite': 'Mövcud seçilmişlərdən seç',
  'label.autopayment.monthly': 'Aylıq',
  'label.autopayment.debt': 'borc üzrə',
  'label.autopayment.schedule': 'qrafik üzrə',
  'label.autopayment.once': 'Birdəfəlik',

  'label.limits': 'Limitlər',

  'label.faq.title': 'Sənə necə köməklik edə bilərik?',
  'label.faq.contact.title': 'Əlaqə üçün keçid',
  'label.faq.address': 'Albert Aqarunov küç. 7B, AZ1075 Bakı, Azərbaycan',
  'label.add.favorite': 'Seçilmişə əlavə et',
  'label.added.favorite': 'Seçilmişlərə əlavə olunub',
  'label.added.description': 'Seçilmiş ödəniş uğurla yaradılıb. Siyahıdan seçilmiş ödənişlərə baxa bilərsən.',
  'label.new.favorite': 'Yeni seçilmiş',
  'label.new.payment': 'Yeni ödəniş',
  'label.choose.operation': 'Əməliyyat seç',
  'label.choose_from_list': 'Siyahıdan seç',
  'label.create.favorite': 'Seçilmiş yarat',
  'label.new.create.favorite': 'Yeni seçilmiş yarat',
  'label.history.subTitle': 'Terminal ödənişi',
  'label.info.popup.title': 'Kart məlumatları',
  'label.requisite.popup.title': 'Hesab rekvizitəri',
  'label.cobrand.history.title': 'MPAY kart tarixçəsi',
  'label.my.cards': 'Kartlarım',
  'label.cards': 'Kartlar',
  'label.card.order': 'Kart sifarişi',
  'label.card.order.success.title': 'Kart uğurla sifariş edildi',
  'label.card.order.success.desc': 'Zəhmət olmasa filiala yaxınlaşan zaman şəxsiyyət vəsiqəsini özünlə gətir.',
  'label.saved.cards': 'Yadda saxlanılmış kartlarım',
  'label.card.order.title': 'MPAY kart sifarişi',
  'label.card.order.detail.title': 'Ödəniş vaxtında, bu dəfə kartla!',
  'label.card.order.desc': 'Nağdsız ödənişləri rahatlaşdırmağa davam edirik. İndi MPAY kartını pulsuz əldə et, ödənişlərini sürətli və təhlükəsiz şəkildə həyata keçir.',
  'label.card.order.detail.desc': 'MPAY kartı ilə də ödəniş vaxtında prosesi rahatlaşdırmağa davam edirik. Təhlükəsiz ödənişlər və bir çox üstünlük üçün indi sifariş et.',
  'label.panels.header1': 'Kartı necə əldə edə bilərəm?',
  'label.panels.header2': 'Kart balansını necə artıra bilərəm?',
  'label.panels.header3': 'PİN kodu necə təyin edə və ya dəyişdirə bilərəm?',
  'label.panels.header4': 'Kart hesabının qalığına gəlir nə qədərdir?',
  'label.panels.content1': 'Kartı onlayn sifariş edə bilərsiniz. Sifarişdən sonra SMS vasitəsilə kartın hazır olunması prosesi barədə məlumat əldə edəcəksiniz. Hazır olduqda isə seçdiyiniz filialdan götürə bilərsiniz.',
  'label.panels.content2': 'Kart balansını ödəniş terminalları vasitəsilə artırmaq mümkündür.',
  'label.panels.content3': '"MPAY" tətbiqi vasitəsilə PİN kodu təyin edə və ya dəyişə bilərsən.',
  'label.panels.content4': 'Kart hesabına illik qalıq X% təyin edilmişdir.',
  'label.advantages.title1': 'Pulsuz nağdlaşdırma',
  'label.advantages.title2': 'Pulsuz kartdan karta əməliyyatları',
  'label.advantages.title3': 'Pulsuz PİN təyini və dəyişdirilməsi',
  'label.advantages.title4': 'Hesaba pulsuz mədaxil',
  'label.advantages.title5': 'Tətbiq və SMS ilə məlumatlandırılma',
  'label.advantages.title6': 'AZN kart hesabının qalığına gəlir illik X% ',
  'label.advantages.desc1': 'Ölkədaxili bütün ATM-lərdə ay ərzində 5 dəfə pulsuz nağdlaşdırma imkanından yararlana bilərsən.',
  'label.advantages.desc2': 'MPAY kartları arası köçürməni həyata keçirə bilərsən. Ölkə daxili bank kartlarına isə 0,5% komissiya tətbiq olunur.',
  'label.advantages.desc3': 'MPAY tətbiqinə daxil olaraq yeni PİN təyini və dəyişdirilməsini rahat və ödənişsiz həyata keçirə bilərsən.',
  'label.advantages.desc4': 'Terminallardan, eləcə də MPAY cüzdanından hesabına heç bir əlavə ödəniş olmadan mədaxil edə bilərsən.',
  'label.advantages.desc5': 'Tətbiq vasitəsilə əməliyyatları izləmə və SMS ilə məlumatlandırılma üstünlüyü mövcuddur.',
  'label.advantages.desc6': 'Hesabın qalığı üzrə ay ərzində hesablanmış faiz məbləği hər ayın son iş günü kart hesabına köçürülür.',
  'label.card.tabLink1': 'Kart haqqında',
  'label.card.tabLink2': 'Üstünlüklər',
  'label.card.tabLink3': 'Əlavə məlumat',
  'label.card.type': 'Kart növü',
  'label.order.date': 'Sifariş tarixçəsi',
  'label.status': 'Status',
  'label.cobrand.settings.title': 'MPAY kartın tənzimlənməsi',
  'label.cardholder.name': 'Kart sahibinin adı',
  'label.card.number': 'Kart nömrəsi',
  'label.expiry.date': 'Son istifadə tarixi',
  'label.card.info.popup.desc': 'Bu kart "MPAY" və "Rabitə Bank"ın ortaq məhsuludur.',
  'label.rename.title': 'Ad dəyişmək',
  'label.my.mpay.card': 'MPAY kartım',
  'label.mpay.card': 'MPAY kart',
  'label.recipient.name': 'Alıcının adı',
  'label.buyer.account': 'Alıcının hesabı',
  'label.receiving.bank': 'Qəbul edən bank',
  'label.swift': 'SWIFT',
  'label.vöen': 'VÖEN',
  'label.bank.code': 'Bank kodu',
  'label.reporter.account': 'Müxbir hesab',
  'label.blocked': 'Kart bloklanıb',
  'label.block.card.title': 'Kartı blokla',
  'label.block.card.desc': 'Kartı bloklasan, kartla əməliyyatlar etmək mümkün olmayacaq. İstəyəndə kartı blokdan çıxara bilərsən.',
  'label.unblock.card.title': 'Kartı blokdan çıxar',
  'label.unblock.card.desc': 'Kartı blokdan çıxardıqdan sonra əməliyyatlara yenidən başlaya bilərsən.',
  'label.reset.pin.title': 'PİN cəhdlərini sıfırlamaq',
  'label.reset.pin.desc': 'Daha 3 cəhd əldə etmək üçün keçid et.',
  'label.transfer.amount': 'Köçürmə məbləği',
  'label.transfer.source': 'Köçürmə mənbəyi',
  'label.phone.number': 'Mobil nömrə',
  'label.branch.delivery': 'Çatdırılma üçün filial',
  'label.secret.word': 'Gizli söz',
  'label.card.order.status': 'Sifariş olunmuş MPAY kart sorğun var.',
  'label.pin.code': 'FİN kod',
  'label.fill.information.order': 'Sifariş üçün məlumatları doldur',
  'label.card.benefits': 'Kartın üstünlükləri',
  'label.how.get.card': 'Kartı necə əldə edə bilərəm?',
  'label.fill.form': 'Formu doldur',
  'label.follow.notification': 'SMS məlumatlandırmanı izlə',
  'label.get.card': 'Kartı əldə et',
  'label.annual.service.fee': 'İllik xidmət haqqı',
  'label.free': 'Pulsuz',
  'label.duration': 'Müddət',
  'label.years': '5 il',
  'label.currency': 'Valyuta',
  'label.cashback': 'Keşbek',
  'label.percent': '40%-dək',
  'label.payments': 'Ödənişlər',
  'label.transfers': 'Köçürmələr',
  'label.coupons': 'Kuponlarım',
  'label.coupon': 'Kupon',
  'label.debts': 'Borclarım',
  'label.transfers.wallet': 'Cüzdana Köçürmə',
  'label.top-up': 'Balans artırma',
  'label.card_transfer': 'Kartdan köçürmə',
  'label.wallet_transfer': 'Cüzdandan köçürmə',
  'label.payment_source': 'Ödəniş mənbəyi',
  'label.payment_amount': 'Ödəniş məbləği',
  'label.target_card': 'Mədaxil olunacaq kart',
  'label.share.receipt': 'Qəbzi paylaş',
  'label.call.center.title': 'Əlaqə vasitəsi üçün keçid et',
  'label.personal_info': 'Şəxsi məlumatlar',
  'label.change_password': 'Şifrə dəyişimi',
  'label.select_language': 'Dil seçimi',
  'label.notifications': 'Bildirişlər',
  'label.terms_conditions': 'Şərtlər və qaydalar',
  'label.read_all': 'Oxunmuş kimi qeyd et',
  'label.name_surname': 'Ad, soyad',
  'label.name': 'Ad',
  'label.surname': 'Soyad',
  'label.father_name': 'Ata adı',
  'label.full_name': 'Ad, Soyad, Ata adı',
  'label.pin': 'FİN',
  'label.date_of_birth': 'Doğum tarixi',
  'label.gender': 'Cinsiyyət',
  'label.language': 'Language',
  'label.settings': 'Tənzimləmələr',
  'label.history': 'Tarixçə',
  'label.automobiles': 'Avtomobillər',
  'label.support': 'Dəstək',
  'label.wallet': 'Cüzdanım',
  'label.uber': 'UBER',
  'label.old.wallet': 'Köhnə hesabım',
  'label.old.balance': 'Köhnə MPAY balansım',
  'label.card': 'Kart',
  'label.terminal': 'Terminal',
  'label.last_operations': 'Son əməliyyatlar',
  'label.frequently_used': 'Tez-tez istifadə olunanlar',
  'label.categories': 'Kateqoriyalar',
  'label.no_comission': 'Komissiya yoxdur',
  'label.comission': '{amount} AZN komissiya bu məbləğə əlavə olunacaqdır',
  'label.receipt.failed.operation': 'Uğursuz əməliyyat',
  'label.receipt.failed.payment': 'Uğursuz ödəniş',
  'label.receipt.failed.transfer': 'Uğursuz köçürmə',
  'label.receipt.inprogress.payment': 'Ödəniş icradadır',
  'label.receipt.inprogress.transfer': 'Köçürmə icradadır',
  'label.transfer.receipt.success': 'Köçürmə tamamlandı',
  'label.transfer_target.receipt.success': 'Köçürmə qəbul edildi',
  'label.general.receipt.success': 'Ödəniş tamamlandı',
  'label.success': 'Uğurlu',
  'label.success.card.name': 'Kart adı uğurla dəyişdirildi.',
  'label.success.card.delete': 'Kartla bağlı məlumatlar artıq mövcud deyil.',
  'label.pending': 'İcradadır',
  'label.transfer.title': 'Köçürmə icradadır',
  'label.fail': 'Uğursuz',
  'label.approved': 'Davam edir',
  'label.receipt': 'Qəbz',
  'label.other_operators': 'Digər Operatorlar',
  'label.mno': 'Mobil nömrəni daxil et',
  'label.pay_with_new_card': 'Yeni kartla ödəniş',
  'label.saved_cards': 'Yaddaşdakı kartlarım',
  'label.service.debt.amount': 'Sənin {serviceName} borcun:',
  'label.service.balance.amount': 'Sənin {serviceName} balansın:',
  'label.switch.success_logout': 'Çıxış edildi',
  'label.coupon.coming': 'Sənə hədiyyə balans var',
  'label.coupon.sent': 'Hədiyyə balans göndərildi',
  'label.coupon.sender.gift': 'Hədiyyəni göndərən',
  'label.coupon.pending.title': 'Hədiyyə balans gözləmədədir',
  'label.coupon.pending.status': 'Gözləmədədir',
  'label.coupon.accepted.title': 'Hədiyyə balans qəbul edildi',
  'label.coupon.accepted.status': 'Qəbul edildi',
  'label.coupon.rejected.title': 'Hədiyyə balans qəbul edilmədi',
  'label.coupon.rejected.status': 'Qəbul edilmədi',
  'label.coupon.reversed.title': 'Hədiyyə balans qaytarıldı',
  'label.coupon.reversed.status': 'Qaytarıldı',
  'label.coupon.ready.title': 'Hədiyyə balansın köçürüldü',
  'label.coupon.ready.status': 'Köçürüldü',
  'label.fav.filter': 'Seçilmişləri filterlə',
  'label.fav.ad_new': 'Yeni seçilmiş əlavə et',
  'label.automobile.add_new': 'Yeni avtomobil nömrəsi əlavə et',
  'label.fav.suggest.heading': 'Bəlkə, Seçilmişlərə əlavə edəsən ?',
  'label.fav.suggest.desc': 'Daima borclar haqqında məlumatlı olmaq üçün “Seçilmişlər”ə əlavə et.',
  'label.automobiles.desc': '"Parqour" parkinq ödənişlərinin rahatlığı üçün qeydiyyat nişanlarını buradan idarə et.',
  'label.send.money': 'Pul göndər',
  'label.mpay.download': 'MPAY yüklə',
  'label.mpay.downoad.desc': 'Telefonun kamerası ilə QR kodu skan edərək yüklə',
  'label.change.pin.title': 'PİN-i dəyiş',
  'label.change.pin.new': 'Yeni PİN',
  'label.change.pin.new.reenter': 'Yeni PİN-i təkrar daxil et',
  'label.deposit.deactivate.title': 'Depozit faizini deaktiv et',
  'label.deposit.deactivate.desc': 'Bu halda kartına aylıq depozit faizi hesablanmayacaq',
  'label.deposit.activate.title': 'Depozit faizini aktivləşdir',
  'label.deposit.activate.desc': 'Aktivləşərsə, kartına aylıq depozit faizi hesablanacaq.',
  'label.transition.source': 'keçid mənbəyi',

  // actions
  'action.forgot_password': 'Şifrəni unutmusan?',
  'action.sign_in': 'Daxil ol',
  'action.sign_up': 'Qeydiyyatdan keç',
  'action.send_again': 'Yenidən göndər',
  'action.confirm': 'Təsdiqlə',
  'action.reset_password': 'Bərpa et',
  'action.continue': 'Davam et',
  'action.add_phone_number': 'Yeni nömrə əlavə et',
  'action.back_to_login': 'Giriş səhifəsinə qayıt',
  'action.top_up': 'Balansı artır',
  'action.top_up.wallet': 'Balansı artır',
  'action.top_up.balance': 'Balansı artır',
  'action.wallet_transfer': 'Köçürmə',
  'action.transfer_to_wallet': 'Cüzdana köçürmə',
  'action.repeat': 'Təkrar ödə',
  'action.add_favorite': 'Seçilmişlərə əlavə et',
  'action.added_favorite': 'Seçilmişlərə əlavə edilib',
  'action.share': 'Paylaş',
  'action.download': 'Yüklə',
  'action.mpay.download': 'Yükləmək üçün buradan keçid et',
  'action.look.receipt': 'Qəbzə bax',
  'action.transfer.wallet': 'Cüzdana köçür',
  'action.call.center': 'Müştəri xidmətləri ilə əlaqə',
  'action.all': 'Hamısı',
  'action.success': 'Uğurlu',
  'action.failed': 'Uğursuz',
  'action.in_progress': 'İcrada',
  'action.edit_label': 'Adını dəyiş',
  'action.edit': 'Dəyişiklik et',
  'action.delete': 'Sil',
  'action.delete.question': 'Seçilmişi silmək istədiyinə əminsən?',
  'action.delete.automobile': 'Avtomobili silmək istədiyindən əminsən?',
  'action.logout': 'Çıxış etmək istədiyinə əminsən?',
  'action.fav.pay_debts': 'Borcları ödə',
  'action.fav.pay_all_debts': 'Bütün borcları ödə',
  'action.delete.autopay': 'Avtomatik ödənişi silmək',
  'action.delete.autopay_desc': '{autoPayName}  avtomatik ödənişinin silinməyinə əminsən?',
  'action.search.cancel': 'Ləğv et',
  'action.switch.logout': 'Digər hesablardan çıxış et',
  'action.switch.changePasword': 'Şifrəni dəyiş',
  'action.fav.pay_all_debts_title': 'Ödəniş üçün {amount} AZN çatmır ',
  'action.fav.pay_all_debts_desc': 'Balansında {amount} var. Balansı artır və ödənişi tamamla! 🥳',
  'action.pay': 'Ödə',
  'action.personal_info': 'Personal information',
  'action.change_password': 'Change Password',
  'action.select_language': 'Select language',
  'action.notifications': 'Notifications',
  'action.sign_out': 'Sign out',
  'action.update_info': 'Məlumatları yenilə',
  'action.back': 'Geriyə',
  'action.cancel': 'İmtina',
  'action.remove': 'Sil',
  'action.card.remove': 'Kartı sil',
  'action.save': 'Yadda saxla',
  'action.do_operation': 'Əməliyyat et',
  'action.change': 'Dəyiş',
  'action.close': 'Bağla',
  'action.go_dashboard': 'Əsas səhifəyə qayıt',
  'action.go_automobiles': 'Avtomobillər siyahısına qayıt',
  'action.home': 'Əsas səhifə',
  'action.favorites': 'Seçilmişlər',
  'action.card.order': 'Sifariş et',
  'action.more.detail': 'Daha ətraflı',
  'action.search.autopayment': 'Avtomatik ödənişlərdə axtar',
  'action.rename': 'Kartın adını dəyiş',
  'action.account.requisites': 'Hesab rekvizitləri',
  'action.change.pin': 'PİN-i dəyiş',
  'action.reset.pin': 'PİN cəhdlərini sıfırla',
  'action.set.limits': 'Limitləri təyin et',
  'action.deposit.interest': 'Depozit faizi',
  'action.send.money': 'Pul göndər',
  'action.block': 'Blok et',
  'action.more': 'Daha çox',
  'action.extract': 'Çıxarış',
  'action.soon': 'Tezliklə...',
  'action.try': '3 cəhd əldə et',
  'action.return_automobiles_list': 'Siyahıya qayıt',
  'action.unblock': 'Blokdan çıxar',
  'action.add.favorites': 'Seçilmişlərə əlavə edin',
  'action.order.confirm': 'Sifarişi təsdiqlə',
  'action.look_history': 'Tarixçəyə bax',
  'action.new_automobile': 'Yeni avtomobil',
  'action.add_new_automobile': 'Yeni avtomobil əlavə et',
  'action.deposit.deactivate': 'Deaktiv et',
  'action.deposit.activate': 'Aktiv et',
  'action.limits.table': 'Limitlər cədvəli',
  'action.limits.increase': 'Limiti artır',

  // filters
  'filters.action': 'Filter',
  'filters.period.this_week': 'Son 1 həftə',
  'filters.period.last_month': 'Son 30 gün',
  'filters.period.last_months': 'Son 90 gün',
  'filters.date': 'Tarix',
  'filters.date.title': 'Tarixi seç',
  'filters.transaction.types': 'Əməliyyat növü',
  'filters.coupons.types': 'Kupon növü',
  'filters.transaction.types.top_up': 'Balans artırma',
  'filters.transaction.types.transfer': 'Köçürmə',
  'filters.transaction.types.balance-payment': 'Cüzdandan ödəniş',
  'filters.transaction.types.card-payment': 'Kartdan ödəniş',
  'filters.transaction.types.qr_terminal': 'Terminal əməliyyatı',
  'filters.coupon.types.received': 'Gələnlər',
  'filters.coupon.types.sent': 'Göndərilənlər',
  'filters.transfers': 'Köçürmələr',
  'filter.category': 'Kateqoriya',
  // entities

  // validations
  'validation.self_transfer': 'Eyni hesaba pul göndərmək mümkün deyil.',
  'validation.sercive_disabled': 'Xidmət mövcud deyil.',
  'validation.required': 'Bu xana boş ola bilməz.',
  'validation.number': 'Düzgün rəqəm daxil et.',
  'validation.pattern': 'Daxil edilən məlumat şablona uyğun deyil.',
  'validation.login.number': 'Nömrə tam daxil edilməyib.',
  'validation.maxlength': 'Tələb olunan maksimum limit({maxlength}) aşılıb.',
  'validation.minlength': 'Tələb olunan minimum limit({minlength}) qarşılanmır.',
  'validation.min': 'Minimum-({min}) AZN',
  'validation.max': 'Maximum-({max}) AZN',
  'validation.amount': 'Düzgün rəqəm daxil et.',
  'validation.error.not-enough-ballance': 'Balansda kifayət qədər məbləğ yoxdur',
  'validation.card.number.invalid': 'Kart nömrəsi düzgün daxil edilməyib',
  'validation.card.not.support': 'Yalnız qeyd edilən kartlara köçürmə mümkündür',
  'validation.contains_digits': 'Ən azı 1 rəqəm (0-9)',
  'validation.contains_lower_letters': 'Ən azı 1 kiçik hərf',
  'validation.contains_upper_letters': 'Ən azı 1 böyük hərf',
  'validation.special_symbols': 'Ən azı 1 xüsusi simvol',
  'validation.password_format': 'Şifrə şərtlərə uyğun daxil edilməyib',
  'validation.password_mismatch': 'Şifrə uyğun deyil',
  'server.error.internal': 'Daxili server xətası',
  // pages

  // misc
  'misc.auth.sign_in.title': 'Hesaba daxil ol',
  'misc.auth.reset.title': 'Şifrəni bərpa et',
  'misc.auth.set_new_password.title': 'Yeni şifrə təyin et',
  'misc.auth.without_account': 'Hesabın yoxdur?',
  'misc.auth.login.number': 'Nömrə ilə hesaba daxil ol',
  'misc.auth.sign.app': 'Tətbiqdə qeydiyyatdan keç',
  'misc.auth.with_account': 'Hesabın var?',
  'misc.auth.without_otp_code': 'Kod gəlmədi? ',
  'misc.auth.retry.qr': 'QR kodu yeniləmək üçün kliklə',
  'misc.auth.account.complete.registration': 'Hesabın yoxdur? Qeydiyyatı tətbiq vasitəsilə tamamla:',
  'misc.auth.account.complete.register': 'QR kod ilə tətbiqdə qeydiyyatdan keç',
  'misc.auth.open.camera': 'Telefonda kameranı aç.',
  'misc.auth.scan.qr': 'QR kodu skan et.',
  'misc.auth.download.app': 'Mobil tətbiqi yüklə və ya birbaşa qeydiyyatdan keç.',
  'misc.auth.scan.qr.register': '2. Telefonunla ekrandakı QR-ı skan et.',
  'misc.auth.download.app.register': '3. ”MPAY” mobil tətbiqini yüklə.',
  'misc.auth.account.login.qr_code': 'QR kod ilə giriş',
  'misc.auth.account.login.open_app': '“MPAY” mobil tətbiqini aç.',
  'misc.auth.account.login.enter_scan': '"Skan et" bölməsinə daxil ol.',
  'misc.auth.account.login.scan_to_login': 'Skan edərək dərhal giriş et.',
  'misc.auth.create.title': 'Hesab yaratmaq üçün MPAY tətbiqində qeydiyyatdan keç.',
  'misc.auth.download.app.modal': '“MPAY” tətbiqini yüklə.',
  'misc.auth.download.signUp': 'Tətbiqə daxil olub qeydiyyatdan keç.',
  'misc.auth.using.services': 'Hesabını aktivləşdir və xidmətlərdən faydalan.',
  'misc.common.or': 'və ya',
  'misc.comon.or.uppercase': 'Və ya',
  'misc.common.more': 'Daha çox',
  'misc.common.easy': 'Rahat',
  'misc.common.sima': 'MPAY mobil tətbiqində',
  'misc.auth.sign_up.title': 'Qeydiyyatdan keç',
  'misc.auth.sign_up.agreement': 'Qeydiyyatdan keçərək {0} və {1} ilə razılaşırsan.',
  'misc.auth.sign_up.agreement.terms': 'İstifadə şərtləri, qaydaları',
  'misc.auth.sign_up.agreement.privacy': 'Məxfilik siyasəti',
  'misc.auth.otp.confirm.title': 'Kodu daxil et',
  'misc.auth.otp.label': 'Zəhmət olmasa, <strong>{phone}</strong> nömrəsinə göndərilən <strong>6 rəqəmli kodu</strong> daxil et.',
  'misc.auth.asan.label.select_number': 'Please select the number to continue',
  'misc.suggest.header': '{category} ödənişin tamamlandı',
  'misc.suggest.desc': 'Digər {category} əməliyyatlarının aparılması üçün “{category}” kateqoriyasına keç.',
  'misc.suggest.other_categories': 'Digər {category} ödənişləri üçün keçid et.',
  'misc.suggest.other_debt': 'Digər {category} borcları ödəmək üçün keçid et!',

  'misc.settings.campaigns.title': 'Xidmətlər barədə',
  'misc.settings.campaigns.content': 'Kampaniyalar, xidmətlər barədə bildiriş al',
  'misc.settings.debt.title': 'Borc ödənişləri',
  'misc.settings.debt.content': 'Ödəniş vaxtı olduğu zaman əvvəlcədən bu barədə bildiriş al',
  'misc.settings.password.info': 'The new password must be at least 8 characters long and contain at least 1 uppercase letter, lowercase letters and numbers.',
  'misc.settings.notifications.info': 'You can choose the type of notification you want.',
  'misc.settings.notifications.type.app': 'App',
  'misc.settings.notifications.type.email': 'Email',
  'misc.settings.notifications.type.email.address': 'Email ünvanı',
  'misc.settings.notifications.type.sms': 'Sms',
  'misc.settings.notifications.empty': 'Bildirişin yoxdur. Kəşfə davam!',
  'misc.settings.gender.male': 'Kişi',
  'misc.settings.gender.female': 'Qadın',
  'misc.settings.language.az': 'Azərbaycan',
  'misc.settings.language.eng': 'İngilis',
  'misc.settings.language.ru': 'Rus',
  'misc.settings.terms_conditions.terms.title': 'İstifadə Şərtləri',
  'misc.settings.terms_conditions.privacy.title': 'Məxfilik Siyasəti',
  'misc.settings.terms_conditions.tariffs.title': 'Tariflər',
  'misc.settings.profile.personal': 'Şəxsi məlumatlar',
  'misc.settings.profile.password': 'Şifrə dəyişimi',
  'misc.settings.profile.language': 'Dil seçimi',
  'misc.settings.profile.notification': 'Bildirişlər',
  'misc.settings.profile.terms_conditions': 'Şərtlər və qaydalar',
  'misc.settings.profile.logout': 'Hesabdan çıxış',
  'misc.settings.profile.password-warning': 'Yeni şifrə ən az 8 simvolu əhatə etməklə tərkibində ən azı 1 böyük hərf, kiçik hərflər və rəqəmlərdən ibarət olmalıdır.',
  'misc.saved.remove.desc': 'Bu kartla bağlı məlumatlar silinəcək.',
  'misc.saved.remove.title': 'Kart silinsin?',
  'misc.saved.update.title': 'Adını dəyiş',
  'misc.card.update.title': 'Kart adını dəyiş',
  'misc.saved.update.info': 'Məlumatı yenilə',
  'misc.saved.add.title': 'Ad təyin et',
  'misc.saved.index.empty': 'Heç bir kart tapılmadı.',
  'misc.support.search.empty': 'Axtarışa uyğun nəticə tapılmadı.',
  'misc.history.automobile.empty': 'Heç bir avtomobil tapılmadı.',
  'misc.history.index.empty': 'Heç bir əməliyyat tapılmadı.',
  'misc.coupon.index.empty': 'Heç bir kupon tapılmadı.',
  'misc.history.search.empty': 'Axtarışa uyğun əməliyyat tapılmadı.',
  'misc.coupon.search.empty': 'Axtarışa uyğun kupon tapılmadı.',
  'misc.history.day.yesterday': 'Dünən',
  'misc.history.day.today': 'Bugün',

  'misc.category.search.placeholder': 'Xidmət adını daxil et',
  'misc.category.search.no_results': 'Axtarışa uyğun xidmət tapılmadı.',

  'misc.fav.remove.title': 'Seçilmişi sil',
  'misc.fav.index.empty': 'Axtarışa uyğun seçilmiş tapılmadı.',
  'misc.fav.search.placeholder': 'Axtar',
  'misc.fav.input.placeholder': 'Seçilmişin adı',
  'misc.fav.debt.last_update': 'Borcların son yenilənmə vaxtı:',
  'misc.fav.debt.request': 'Borc sorğusu',
  'misc.fav.debt.request.warning_message': 'Borc sorğulama 1 saatda bir dəfə edilə bilər.',
  'misc.fav.total_amount.title': 'Ümumi məbləğ:',
  'misc.fav.debt_payment.title': 'Borcların ödənişi',
  'misc.fav.debt_payment_approve': 'Ödənişin təsdiqi',
  'misc.fav.debt_payment_category': 'Seçilmişlər/Borclarım',
  'misc.fav.debt.payment.date': 'Əməliyyat tarixi',
  'misc.fav.debt.payment.category': 'Xidmət',
  'misc.fav.debt.payment.amount': 'Məbləğ',
  'misc.fav.debt.payment.commission': 'Komissiya',
  'misc.fav.debt.payment.totalAmount': 'Ümumi məbləğ',
  'misc.fav.debt.payment.source': 'Ödəniş mənbəyi',
  'misc.fav.autopayment.label': 'Ödənişi avtomatik yerinə yetir',
  'misc.fav.inactive.title': 'Xidmət müvəqqəti işləmir',
  'misc.fav.inactive.description': 'Aktiv olduqda yenidən cəhd edə bilərsən',
  'misc.autopayment.frequency': 'Ödəniş tezliyi',
  'misc.autopayment.last.PaymentDate': 'Son ödəniş tarixi',
  'misc.limits.monthly.error': 'Qalan limit (aylıq): {amount}.',
  'misc.limits.daily.error': 'Qalan limit (gündəlik): {amount}.',
  'misc.limits.description': 'Daha çox ödəniş və köçürmə etmək üçün əvvəlcə tanış olmalıyıq. Bunun üçün limiti artır.',
  'misc.limits.verified.description': 'İndi daha çox ödəniş və köçürmə edə bilərsən, çünki sənə inanırıq. 💙',
  'misc.limits.procedures': 'Bu prosedurlar "Ödəniş xidmətləri və ödəniş sistemləri" haqqında qanuna əsasən tənzimlənir.',
  'misc.limits.warning.info': 'Limitlər cədvəli yalnız eyniləşdirilmiş istifadəçilərə aiddir.',
  'misc.limits.verified.warning.info': 'Artırılmış limitlərə limit cədvəli vasitəsilə baxa bilərsən.',
  'misc.limits.PAYMENT.title': 'Ödəniş üzrə aylıq limit',
  'misc.limits.TOP_UP.title': 'Cüzdan üzrə aylıq limit',
  'misc.limits.PAYMENT.limit.tooltip': 'Bu limit həm cüzdan, həm də kartla edilən ödəniş və köçürmələr üçün nəzərdə tutulub.',
  'misc.limits.TOP_UP.limit.tooltip': 'Bu limit cüzdan və kart vasitəsilə mədaxil olunan məbləğlər üçün nəzərdə tutulub.',
  'misc.limits.will_update': 'Yenilənəcək:',
  'misc.limits.identification': 'Limitlərini artırmaq üçün eyniləşdirməni tamamla',

  'misc.transfer.add_to_fav.title': 'Seçilmişlərə əlavə et',
  'misc.transfer.to_card.info': 'Karta köçürmə əməliyyatı yalnız Rabitə Bank, Kapital Bank, Bank Respublika, Xalq Bank və ABB Bank kartlarına şamil olunur.',
  'misc.transfer.card': 'Kart',
  'misc.transfer.mpay': 'Mpay cüzdan',

  'misc.transfer.confirm': 'Ödənişin təsdiqi',
  'misc.transfer.confirm.wallet-transfer': 'Cüzdana köçürmə',
  'misc.transfer.confirm.amount': 'Məbləğ',
  'misc.transfer.confirm.amount.currency': 'AZN',
  'misc.transfer.confirm.commission': 'Komissiya',
  'misc.transfer.confirm.all_amount': 'Ümumi məbləğ',
  'misc.transfer.receipt.account': 'Abunəçinin kodu',
  'misc.transfer.receipt.sender': 'Köçürən',
  'misc.transfer.receipt.receiver': 'Qəbul edən',
  'misc.transfer.receipt.status': 'Əməliyyat statusu',
  'misc.transfer.receipt.date': 'Əməliyyat tarixi',
  'misc.transaction.number': 'Əməliyyat nömrəsi',
  'misc.transaction.reversed': 'Məbləğ geri qaytarıldı',
  'misc.terminal.inserted': 'Daxil edildi',
  'misc.terminal.address': 'Ünvan',
  'misc.terminal.paid': 'Ödənildi',
  'misc.transfer.receipt.id': 'Qəbz nömrəsi',
  'misc.transfer.receipt.category': 'Xidmət',
  'misc.transfer.receipt.type': 'Köçürmə',
  'misc.transfers.commission.warning': '1 % komissiya ({commission} AZN) bu məbləğə əlavə olunacaqdır.',
  'misc.coupon.receipt.id': 'Kupon nömrəsi',
  'misc.coupon.receipt.recipient.gift': 'Hədiyyəni alan',
  'misc.coupon.receipt.submitted.date': 'Təqdim ediləcəyi tarix',
  'misc.coupon.receipt.influencer': 'İnflunser kodu',
  'misc.coupon.receipt.message': 'Təbrik mesajı',

  'misc.notify.general.success': 'Uğurlu əməliyyat!',
  'misc.notify.general.payment_accepted': 'Ödəniş qəbul edildi',
  'misc.notify.personal.success': 'Məlumatlar uğurla yeniləndi',
  'misc.notify.general.error': 'Xəta baş verdi.',
  'misc.notify.general.error.desc': 'Əməliyyat zamanı xəta baş verdi. Bir az sonra yenidən cəhd et.',
  'misc.notify.general.warning': 'Xəbərdarlıq',
  'misc.receipt.code.copy': 'Qəbz nömrəsi kopyalandı',
  'misc.notify.bulk.commission.failed': 'Bu ödənişdə komissiya hesablana bilər',

  'misc.payment.confirm.commission': 'MPAY komissiyası',
  'misc.payment.source': 'Ödəniş mənbəyi',
  'misc.payment.mpay': 'Mpay cüzdanı:',
  'misc.my_wallet': 'Cüzdanım',
  'misc.second.payment.source': 'Ehtiyyat ödəniş mənbəyi',

  'misc.app.bar.userfirstname': 'Ad',
  'misc.app.bar.account': 'Hesab',
  'misc.app.search.placeholder': 'Axtar',
  'misc.app.search.not_found': 'Heç bir nəticə tapılmadı.',
  'misc.main_page': 'Əsas səhifə',
  'misc.go.main_page': 'Əsas səhifəyə qayıdın.',
  'misc.autopayment.success.desc': 'Avtomatik ödəniş uğurla yaradıldı!',
  'misc.under_development.header': 'Hmm, görünür, texniki təkmilləşdirmə zamanı gəlib!',
  'misc.under_development.contetnt': 'Qısa zamanda MPAY 2.0 ödəniş aləminə qayıdacaqsan! </br> Sən də bir kofe içib bu gözləmə vaxtını dəyərləndirə bilərsən ☕',
  'misc.under_development.recommend': 'Və ya bu müddətdə',
  'misc.under_development.download_app': '<b>MPAY 2.0</b> <br/> tətbiqimizi yüklə',
  'misc.under_development.follow.fb': 'Bizi <br/> <b>İnstagramda</b> izlə',
  'misc.under_development.follow.ig': 'Bizi <br/> <b>Facebookda</b> izlə',
  'misc.sima.verified': 'Eyniləşdirilib',
  'misc.sima.not_verified': 'Eyniləşdirilməyib',
  'misc.copied': 'Kopyalandı',
  'misc.sima.verified.with': 'ŞV ilə eyniləşdirmə et',
  'misc.sima.verified.recommend': 'Limitin artırılması və bütün xidmətlərdən yararlanmaq üçün <span style="font-weight: 500">"MPAY" mobil tətbiqində</span> kimliyini təsdiqlə.',
  'misc.app.download.qr': '"MPAY" mobil tətbiqini yükləmək üçün QR kodu skan et',
  'misc.sima.proceed': 'Keçid et',
  'misc.ads.guest.title': 'Mobil tətbiqlə daha rahat 🚀  İndi keçid et!',
  'misc.ads.guest.desc': 'Mobil tətbiqlə ödənişlərin statusundan anında xəbərdar ola, yeni xidmətləri tanıya və yaxınına pul köçürə bilərsən.',
  'misc.ads.guest.guide': 'Telefonun kamerası ilə QR kodu skan edərək keçid et',

  'misc.tour.heading': 'MPAY dünyasına xoş gəlmisən!🤩',
  'misc.tour.message': 'Üstünlüklərmizlə tanış ol və ödənişlərin rahatlığından zövq al!💙',
  'misc.tour.message_1': 'Bildirişləri idarəetmə panelindən izləyə və tənzimləyə bilərsən.',
  'misc.tour.message_2': 'İstədiyin vaxt cüzdan balansını artıra bilərsən.',
  'misc.tour.message_3': 'Buradan dostunun MPAY cüzdanına köçürmə edə bilərsən.',
  'misc.tour.message_4': 'Ödənişlərini "Seçilmişlər"ə əlavə edib, bir kliklə tamamlaya bilərsən.',
  'misc.tour.message_5': '“Avtomatik ödənişlər"ə keçid et və ödənişlərini avtomatlaşdır.',
  'misc.tour.message_6': 'Həm MPAY cüzdanına, həm də bank kartlarına mədaxil edə bilərsən.',
  'misc.tour.next': 'Növbəti',
  'misc.tour.prev': 'Əvvələ',
  'misc.tour.skip': 'Keç',
  'misc.tour.end': 'Bağla',
  // Sag paneldən ümumi seçilmişlərə baxa bilərsiniz. this text will add above after design finish
};
